module.exports = __webpack_public_path__ + "img/43.6dd069ab.jpg";